<template>
  <div v-show="isLoggedIn"  class="py-2 m-0 bg-gray-100 border-b border-gray-200">
    <div class="px-6 pt-2 pb-2 flex justify-end items-center">
      <base-button
          v-if="!isCoach && isLoggedIn"
          link
          to="/register"
          :mode="'px-3 py-1 text-xs leading-5 font-semibold rounded bg-purple-600 text-white mr-1'"
      >
        <span class="uppercase font-bold tracking-wider">Register as a Coach</span>
      </base-button>

      <base-button
          v-if="isLoggedIn"
          link
          to="/requests"
          :mode="'px-3 py-1 text-xs leading-5 font-semibold rounded bg-yellow-400 text-white mr-1'"
      >Inbox
      </base-button>

      <base-button
          v-if="!isLoggedIn"
          link
          to="/auth"
          :mode="'px-3 py-1 text-xs leading-5 font-semibold rounded bg-purple-400 text-white'"
      >Login / Sign Up to become a Coach
      </base-button>
      <base-button
          v-else
          @click="logout()"
          :mode="'px-3 py-1 text-xs leading-5 font-semibold rounded bg-purple-400 text-white'"
      >Logout
      </base-button>
    </div>
  </div>

  <div class="h-screen flex overflow-hidden bg-white">
    <div class="flex flex-col min-w-0 flex-1 overflow-hidden">
      <div class="flex-1 relative z-0 flex overflow-hidden">

        <aside class="hidden xl:order-first xl:flex xl:flex-col flex-shrink-0 w-96 border-r border-gray-200">
          <CoachesList></CoachesList>
        </aside>

        <main class="flex-1 relative z-0 overflow-y-auto focus:outline-none xl:order-last">

          <div class="xl:hidden">
            <div class="flex items-center justify-between bg-gray-50 border-b border-gray-200 px-4 py-1.5">
              <div class="flex items-center">
                <button type="button" class="-mr-3 h-12 rounded-md text-gray-500 hover:text-gray-900 flex items-center" @click="cSidebarOpen = true">
                  <span class="sr-only">Open sidebar</span>
                  <UserGroupIcon class="h-6 w-6 mr-1" aria-hidden="true" />
                  Directory
                </button>
              </div>
            </div>
            <TransitionRoot as="div" :show="cSidebarOpen">
              <Dialog as="div" static class="fixed inset-0 flex z-40 xl:hidden" @close="cSidebarOpen = false" :open="cSidebarOpen">
                <TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="transition-opacity ease-linear duration-300" leave-from="opacity-100" leave-to="opacity-0">
                  <DialogOverlay class="fixed inset-0 bg-gray-600 bg-opacity-75" />
                </TransitionChild>
                <TransitionChild as="template" enter="transition ease-in-out duration-300 transform" enter-from="-translate-x-full" enter-to="translate-x-0" leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0" leave-to="-translate-x-full">
                  <div class="relative flex-1 flex flex-col max-w-xs w-full bg-white focus:outline-none">
                    <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100" leave-to="opacity-0">
                      <div class="absolute top-0 right-0 -mr-12 pt-2">
                        <button type="button" class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" @click="cSidebarOpen = false">
                          <span class="sr-only">Close sidebar</span>
                          <XIcon class="h-6 w-6 text-white" aria-hidden="true" />
                        </button>
                      </div>
                    </TransitionChild>
                    <div class="flex-1 h-0 pt-5 pb-4 overflow-y-auto">

                      <nav aria-label="Sidebar" class="mt-5 mainNav">
                        <div class="px-2 space-y-1">
                          <CoachesList></CoachesList>
                        </div>
                      </nav>
                    </div>

                  </div>
                </TransitionChild>
                <div class="flex-shrink-0 w-14" aria-hidden="true">
                  <!-- Force sidebar to shrink to fit close icon -->
                </div>
              </Dialog>
            </TransitionRoot>
          </div>


          <slot></slot>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import {
  //MenuIcon,
  XIcon,
  UserGroupIcon,
}
  from '@heroicons/vue/outline'
import { Dialog, DialogOverlay, TransitionChild, TransitionRoot } from '@headlessui/vue'
import CoachesList from "./CoachesList";
import {ref} from "vue";

export default {
  name: "CoachShell",
  components: {
    CoachesList,
    //MenuIcon,
    XIcon,
    UserGroupIcon,
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
  },

  setup() {
    const cSidebarOpen = ref(false)

    return {
      cSidebarOpen,
    }
  },

  computed: {
    isCoach(){
      return this.$store.getters['coaches/isCoach'];
    },
    isLoggedIn(){
      return this.$store.getters.isAuthenticated;
    }
  },
  methods:{
    logout(){
      this.$store.dispatch('logout');
      this.$router.replace('auth');
    }
  }
}
</script>
